const data: any = {
  rt: {
    "b": {
      "thisOpponent": "questo avversario",
      "firstMatch": "Prima partita",
      "lastMatch": "Ultima partita · {{value}}",
      "oneRated": "vs {{name}} {{value}} · 1 partita valutata",
      "average": "vs {{name}} {{value}} · {{count}} partite",
      "oneRatedMe": "contro di me {{value}} · 1 partita valutata",
      "averageMe": "contro di me {{value}} · {{count}} partite",
      "comparisonControls": "Confronti storici",
      "showH2H": "Medie degli scontri diretti",
      "showOverall": "Medie generali di tutte le partite"
    },
    "f": {
      "shot_accuracy": "Precisione dei colpi",
      "call_accuracy": "Precisione delle chiamate (dentro/fuori)",
      "confrontational_tendency": "Tendenza alla contestazione",
      "forehand": "Dritto",
      "backhand": "Rovescio",
      "service": "Servizio",
      "return": "Risposta",
      "volley": "Volée",
      "smash": "Smash",
      "drop_shot": "Smorzata",
      "lob": "Pallonetto",
      "stamina": "Resistenza",
      "speed": "Velocità",
      "court_coverage": "Copertura del campo",
      "tactics": "Tattica",
      "awareness": "Lettura del gioco",
      "shot_variety": "Varietà di colpi",
      "winners": "Vincenti",
      "unforced_errors": "Errori gratuiti",
      "fh_topspin": "Dritto in topspin",
      "fh_slice": "Dritto in slice",
      "bh_topspin": "Rovescio in topspin",
      "bh_slice": "Rovescio in slice",
      "first_serve": "Prima di servizio",
      "first_serve_speed": "Velocità prima",
      "second_serve": "Seconda di servizio",
      "second_serve_speed": "Velocità seconda",
      "serve_flat": "Servizio piatto",
      "serve_kick": "Servizio kick",
      "serve_slice": "Servizio slice",
      "first_serve_pct_est": "Prime in campo (stima)",
      "second_serve_pct_est": "Seconde in campo (stima)",
      "passing_shots": "Passante",
      "volley_d": "Volée",
      "tactics_d": "Tattica",
      "speed_d": "Velocità",
      "stamina_d": "Resistenza",
      "composure": "Lucidità",
      "concentration": "Concentrazione",
      "calmness": "Calma",
      "anxiety": "Ansia",
      "confidence": "Fiducia",
      "fighting_spirit": "Grinta",
      "mental_resilience": "Resilienza mentale",
      "belief_pre": "Fiducia nella vittoria prima del match",
      "belief_in": "Fiducia nella vittoria durante il match"
    },
    "g": {
      "movement": "Movimento e posizionamento",
      "behaviour": "Comportamento",
      "forehand": "Dritto",
      "backhand": "Rovescio",
      "serve": "Servizio",
      "rally": "Scambio e risposta",
      "net": "Gioco a rete",
      "physical": "Fisico e tattica"
    },
    "h": {
      "shot_accuracy": "Quanto spesso i tuoi colpi sono andati dove volevi?",
      "call_accuracy": "Quanto pensi fossero precise le tue chiamate dentro/fuori?",
      "confrontational_tendency": "Tendenza a discussioni, tensioni o contestazioni con l'avversario."
    },
    "dist": {
      "winnersIncl": "Vincenti (ace inclusi)",
      "unforcedIncl": "Errori gratuiti (doppi falli inclusi)",
      "assignTo": "Assegna il {{n}}% restante a…",
      "countHint": "Hai registrato {{a}} ace e {{d}} doppi falli.",
      "remainingInline": "Restano {{n}}%",
      "complete": "Completo — 100% assegnato",
      "assignRemainder": "Assegna qui il {{n}}% restante",
      "tab": "Punti",
      "title": "Come finivano i punti?",
      "helper": "È una tua stima: non serve contare punto per punto. Vanno bene numeri approssimativi, oppure puoi lasciare vuoto.",
      "winners": "Vincenti",
      "forced": "Errori forzati",
      "unforced": "Errori gratuiti",
      "df": "Doppi falli",
      "total": "Totale",
      "remaining": "{{n}}% non assegnato",
      "over": "{{n}}% oltre 100",
      "myTeam": "La mia coppia",
      "oppTeam": "Squadra avversaria"
    }
  },
  onboarding: {
    eyebrow: "Inizia",
    valueHistory: "Costruisci lo storico completo delle tue partite",
    valueStats: "Comprendi le tue statistiche",
    valueImprove: "Segui i tuoi progressi nel tempo",
    showMore: "Come funziona e funzionalità",
    showLess: "Mostra meno",
    headlineDashboard: "La tua dashboard aspetta la prima partita",
    headlineMatches: "Registra una partita per iniziare la tua storia",
    headlineStats: "Le statistiche si sbloccano dopo la prima partita",
    intro: "Tennis Log trasforma ogni partita in insight. Registra la prima in meno di un minuto e vedi la dashboard, i grafici e il coach IA prendere vita.",
    cta: "+ Registra la prima partita",
    howTitle: "Come funziona",
    s1Title: "Aggiungi una partita",
    s1Desc: "Tocca «Nuova partita», compila data, avversario, campo e punteggi. I menu rendono tutto veloce.",
    s2Title: "Aggiungi dettagli (opzionale)",
    s2Desc: "Game per game, condizioni, doppi falli, valutazioni — quanto vuoi, o solo il punteggio.",
    s3Title: "Guarda le tue stats",
    s3Desc: "Win rate, hold rate, break rate, set, game, superficie, campo, avversario — tutto si aggiorna subito.",
    s4Title: "Ricevi insight IA",
    s4Desc: "L’analisi IA è disponibile dopo aver registrato dati delle partite e, in genere, diventa più informativa man mano che cresce il tuo storico.",
    benefitsTitle: "Cosa vedrai con le partite registrate",
    b1Title: "Win rate complessivo",
    b1Desc: "Filtra per anno, formato (singolo/doppio/misto) e tipo (amichevole/ufficiale). Trend per stagione.",
    b2Title: "Set, game, hold & break",
    b2Desc: "Oltre V/S: quanto tieni la battuta, quanto strappi, differenza set e game.",
    b3Title: "Statistiche smartwatch",
    b3Desc: "Carica uno screenshot da Mi Fitness, Garmin, Apple Watch o Zepp — l'IA riempie calorie, BPM e zone FC.",
    b4Title: "Heatmap game per game",
    b4Desc: "Scopri se crolli al game 3 o chiudi il game 11 — per lato di battuta e set.",
    b5Title: "Valutazioni performance",
    b5Desc: "Valuta dritto, rovescio, servizio, risposta, volée, lettura, copertura. Tutto in radar chart.",
    b6Title: "Coach IA",
    b6Desc: "Una narrazione personale di forze, debolezze e schemi — scritta come un coach, dai tuoi dati.",
    tipsTitle: "Consigli per la prima registrazione",
    tip1: "Parti semplice: data, avversario e punteggi bastano.",
    tip2: "Aggiungi campo e superficie — col tempo vedrai dove giochi meglio.",
    tip3: "Prova un set game per game per sbloccare hold rate e heatmap.",
    tip4: "Valutati onestamente — bastano poche voci a nutrire l'IA.",
    tip5: "Hai vecchie partite? Inseriscile. La storia crea le statistiche.",
  },
  nav: { dashboard: "Dashboard", matches: "Partite", add: "Nuova partita", stats: "Stats", insights: "Insights IA", logout: "Esci" , settings: "Impostazioni", invite: "Invita un amico" },
  brand: { name: "My Tennis Ledger", tagline: "Migliora studiando la tua storia tennistica" },
  auth: { age16: "Confermo di avere almeno 16 anni. Gli account Tennis Log sono per persone dai 16 anni in su.", age16Required: "Conferma di avere almeno 16 anni.", signIn: "Accedi", signUp: "Registrati", email: "Email", password: "Password", name: "Nome", createAccount: "Crea account", or: "o", continueGoogle: "Continua con Google", welcomeBack: "Bentornato!", accountCreated: "Account creato!", passwordInfoLabel: "Requisiti della password", passwordHelp: "Usa almeno 8 caratteri. Maiuscole, numeri o simboli non sono obbligatori, ma evita password molto comuni o facili da indovinare. Le password comparse in violazioni note non vengono accettate.", passwordTooShort: "La password deve contenere almeno 8 caratteri.", passwordWeakLeaked: "Questa password è troppo comune o è comparsa in una violazione nota. Prova una password più unica.", passwordRejected: "Questa password non è stata accettata. Controlla i requisiti accanto al campo e riprova.", passwordMinLabel: "Almeno 8 caratteri", requirementMet: "requisito soddisfatto", requirementNotMet: "requisito non ancora soddisfatto", sameMethodHint: "Usa lo stesso metodo di accesso utilizzato per creare il tuo account.", signInFailed: "Email o password non corretti. Se hai creato l'account con Google, accedi con Google." },
  authPage: {
    heroTitle: "Inizia a costruire la tua storia nel tennis",
    heroSubtitle: "Registra le partite in pochi minuti, individua i tuoi pattern e lascia che le statistiche ti mostrino cosa migliorare.",
    trustFree: "Funzioni base gratuite",
    trustData: "I tuoi dati restano tuoi",
    trustDevice: "Funziona su mobile e web",
    dashboardAlt: "Dashboard di Tennis Log con percentuale vittorie, set, game e hold",
    dashboardCaption: "Dopo poche partite la tua dashboard inizia a mostrare percentuale vittorie, hold, break, tendenze e insight AI.",
    founderQuote: "Ho creato Tennis Log perché volevo smettere di dimenticare le mie stesse partite. Basta giocare, ricordare l'andamento del punteggio e registrarlo. Sono sicuro che sarà utile anche a te. Divertiti!",
    founderTitle: "Fondatore di Tennis Log — My Tennis Ledger",
    founderLocation: "Giocatore avanzato a livello di club, Grecia",
    notReadyTitle: "Non ancora pronto a registrarti?",
    notReadySub: "Esplora prima i contenuti pubblici — tutto aperto, nessun account necessario.",
    viewDemoTitle: "Guarda la demo pubblica",
    viewDemoDesc: "Scopri cosa rivela Tennis Log dopo ~25 partite — con grafici reali.",
    readGuideTitle: "Leggi la Guida alle Statistiche del Tennis",
    readGuideDesc: "Quali statistiche contano davvero e come leggerle.",
    browseBlogTitle: "Sfoglia il Blog",
    browseBlogDesc: "Articoli su hold/break, tendenza vittorie, smartwatch, insight AI e gioco mentale.",
    open: "Apri",
  },
  common: {
    all: "Tutti", singles: "Singolo", doubles: "Doppio", mixed: "Misto",
    friendly: "Amichevole", official: "Ufficiale",
    me: "Io", opponent: "Avversario", year: "Anno", draw: "Pareggio",
    cancel: "Annulla", save: "Salva", saving: "Salvataggio...", loading: "Caricamento...",
    delete: "Elimina", edit: "Modifica", search: "Cerca", close: "Chiudi",
    matches: "partite", other: "Altro (specifica)",
    loadFailed: "Impossibile caricare i tuoi dati", loadFailedBody: "Qualcosa è andato storto durante il caricamento. Controlla la connessione e riprova.", retry: "Riprova",
  },
  conditions: { sun: "Sole negli occhi", wind: "Vento", noise: "Rumore / pubblico", cold: "Freddo", rain: "Pioggia", slippery: "Campo scivoloso", humidity: "Umidità", strong_wind: "Vento forte" },
  dashboard: {
    title: "Dashboard", subtitle: "La tua stagione a colpo d'occhio.",
    newMatch: "+ Nuova partita", statsFilter: "Filtro stats", trendFilter: "Filtro trend",
    trendTitle: "Andamento win rate", recent: "Partite recenti", seeAll: "Tutte →",
    noMatches: "Nessuna partita.", addFirst: "Aggiungi la prima",
    noFilter: "Nessuna partita per questo filtro.",
    overallWinRate: "Win rate complessivo", winRate: "Win rate", clickDot: "Clicca per modificare il match", sets: "Set", games: "Game", holdRate: "Hold rate",
    breaksWon: "Break vinti", breaksWonSub: "{{breaks}} su {{total}} game di risposta",
    serviceGames: "game al servizio", returnGames: "game di risposta",
    winAfterFirstSet: "Vittoria dopo aver vinto il 1° set", winAfterFirstSetSub: "{{wins}} su {{total}} match", surfaceFilter: "Superficie",
    setsWon: "Set vinti", gamesWon: "Game vinti", breakRate: "Percentuale break",
    currentForm: "Forma attuale", formEmpty: "Nessuna partita completata",
    trendDelta: "Win rate {{pp}} pp vs i 10 precedenti",
    trendStable: "Win rate stabile vs i 10 precedenti",
    trendUnavailable: "Trend disponibile dopo {{count}} partite",
    discovery: {
      title: "Cosa ti dice il tuo tennis",
      family: { improving: "In crescita", edge: "Il tuo punto di forza", watch: "Da monitorare" },
    },
  },
  match: {
    opponentPrivacyHint: "Facoltativo. Queste informazioni riguardano un’altra persona: annota solo ciò che serve alla tua analisi e resta ai fatti.",
    basics: "Dati", players: "Giocatori", score: "Punteggio per set",
    invalidSetScore: "Punteggio impossibile nel set {{set}} — il vincitore deve raggiungere il target con 2 di vantaggio.", notes: "Note",
    watch: "Dati smartwatch", rating: "Valutazione partita (1–10)",
    surface: "Superficie", temperature: "Temperatura ({{unit}})",
    setType: "Tipo set", standardSet: "Standard", shortSet: "Short Set (a 4 game)", superTb: "Super TB (10p)", tb7: "Tie-break 7p", tb11: "Tie-break 11p",
    tbPointByPoint: "Punto per punto", tbUndo: "Annulla", tbClear: "Cancella", tbDecided: "Concluso",
    date: "Data", time: "Ora", day: "Giorno", court: "Campo", courtCustomPlaceholder: "es. Club Court #1",
    format: "Formato", kind: "Tipo",
    set: "Set", firstServer: "Primo servizio:",
    missingOpponent: "Inserisci il nome dell'avversario per salvare la partita.", missingCourt: "Inserisci il nome del campo per salvare la partita.",
    opponentRequired: "Avversario *", myPartner: "Mio compagno", oppPartner: "Compagno avversario",
    teams: "Squadre", teamsHint: "La mia squadra (io + compagno) vs squadra avversaria (avversario 1 + avversario 2).",
    myTeam: "La mia squadra",
    opponentTeam: "Squadra avversaria",
    opponent1: "Avversario 1",
    opponent2: "Avversario 2",
    doublesPlayersRequired: "Inserisci il compagno e i due avversari per salvare il doppio.",
    age: "Età", experience: "Anni di esperienza", backhand: "Rovescio", playstyle: "Stile di gioco",

    notesPlaceholder: "Com'è andata la partita?",
    summaryTab: "Riepilogo", detailedTab: "Dettagliato",
    watchHint: "Carica screenshot Mi Fitness/Garmin/Apple Watch — auto-compilato via AI.",
    ratingHint: "Lascia vuoto ciò che non vuoi valutare.",
    saveMatch: "Salva", saveChanges: "Salva",
    addTitle: "Nuova partita", addSubtitle: "Compila i dettagli.",
    editTitle: "Modifica partita", editSubtitle: "Aggiorna e salva.",
    saved: "Partita salvata!", changesSaved: "Modifiche salvate!", notFound: "Partita non trovata",
    retired: "C'è stato un ritiro?", retiredNone: "No", retiredYes: "Sì", retiredMe: "Mi sono ritirato", retiredOpp: "Avversario ritirato",
    specialEnding: "Fine partita particolare",
    scoreMismatchTitle: "Il punteggio non coincide",
    scoreMismatchBody: "Dall'andamento registrato risulta {{derived}}, mentre nel punteggio finale hai indicato {{declared}}. Controlla prima di continuare.",
    scoreMismatchFix: "Correggi il punteggio finale",
    declaredScore: "Punteggio dichiarato",
    declaredScoreHint: "Questo è il punteggio finale del Passaggio 1. Ora indica come si è svolto il set.",
    declaredScorePrompt: "Hai indicato che il <highlight>Set {{set}} è finito {{score}}</highlight>. Ora mostra come si è sviluppato il punteggio.",
    incompleteSetTimePrompt: "Hai indicato che il <highlight>Set {{set}} è arrivato a {{score}}</highlight> senza concludersi, probabilmente perché il tempo è scaduto. Inserisci solo i games giocati affinché vengano considerati nell’Elo.",
    timelineLiveScore: "Punteggio game-by-game in corso",
    scoreMismatchBlock: "Il punteggio game-by-game non coincide con il punteggio finale. Correggi la differenza prima di continuare.",
    gameSequenceNext: "Inserisci i game in ordine · Prossimo: Game {{game}}",
    gameSequenceGap: "Manca il Game {{missing}} prima del Game {{later}}. Compilalo prima.",
    gameSequenceBlock: "Completa i game mancanti nell’ordine corretto prima di continuare.",
    doubleFaults: "Doppi falli",
    dfMe: "Miei doppi falli",
    dfOpp: "Doppi falli avversario",
    aces: "Ace",
    acesMe: "Miei ace",
    acesOpp: "Ace avversario",
    context: "Contesto e condizioni",
    contextHint: "Fattori esterni e personali che possono aver influito sulla partita.",
    conditions: "Condizioni fisiche",
    personalIssues: "Difficoltà personali",
    personalIssuesPlaceholder: "es. mal di testa, dolore al ginocchio, stanchezza…",
    psychTab: "Psicologia",
    oppAge: "Età dell'avversario",
    oppBackhand: "Rovescio dell'avversario",
    bhSingle: "A una mano",
    bhDouble: "A due mani",
    oppPlaystyle: "Stile di gioco",
    styleOffensive: "Offensivo",
    styleDefensive: "Difensivo",
    styleAllCourt: "All-court",
    floodlights: "Sotto i riflettori",
    rainy: "Tempo piovoso",
    tiringDay: "Giornata stancante / dura al lavoro",
    napped: "Pisolino pomeridiano",
    heavyMeal: "Pasto pesante",
    fasted: "A digiuno",
    anxiousFlag: "Ansioso",
    tournamentRound: "Turno del torneo",
    tournamentName: "Nome del torneo",
    sleepHours: "Sonno la notte scorsa (ore)",
    ballsState: "Stato delle palline",
    ballsNew: "Nuove", ballsUsed: "Usate",
    ballsUseCount: "Quante volte usate",
    ballsUseSuffix: "x",
    oppExperience: "Anni di esperienza",
    racketStrungAt: "Racchetta incordata il",
    racketStrungAgo: "{{n}} giorni fa",
    racketStrungToday: "oggi",
    individualConditions: "Condizioni personali",
    daysSinceLastMatch: "Giorni dall'ultimo match",
    daysAgo: "{{n}} giorni fa",
    ballsUsed1: "Usate 1x", ballsUsed2: "Usate 2x", ballsUsed3: "Usate 3x",
    oppHandedness: "Mano", righty: "Destrorso", lefty: "Mancino",
    weightKg: "Peso ({{unit}})", bmi: "BMI", bmiNoHeight: "Imposta la tua altezza nel profilo per calcolare il BMI",
    hLegend: "H = Hold", bLegend: "B = Break",
    cellHowTo: "Un clic sulla cella di chi serve per Hold (H), doppio clic per Break (B). Un altro clic svuota la cella.",
    gameDetail: {
      toggle: "Aggiungi dettaglio per game",
      toggleHint: "Facoltativo: tocca un game concluso per registrare fino a quale punteggio è arrivato chi lo ha perso.",
      gameN: "Game {{n}}",
      openSheet: "Aggiungi dettaglio",
      youServed: "servivi tu", oppServed: "serviva l'avversario",
      held: "hold", wasBroken: "sei stato brekkato", oppHeld: "hold dell'avversario", youBroke: "hai brekkato",
      question: "Fin dove è arrivato chi ha perso il game?",
      deuce: "Deuce",
      gamePointQuestion: "Chi ha perso ha avuto una palla game?",
      yes: "Sì", no: "No",
      clearDetail: "Cancella dettaglio", changeResult: "Cambia risultato",
      hold: "Hold", break: "Break", clearResult: "Cancella risultato",
      token: { "0": "Arrivato a 0", "15": "Arrivato a 15", "30": "Arrivato a 30", D: "Deuce, senza palla game", DG: "Deuce, con palla game" },
    },
  },
  matches: {
    title: "Partite", subtitle: "Tutto il tuo storico.",
    searchOpponent: "Cerca avversario", searchPlaceholder: "es. Rossi",
    format: "Formato", confrontation: "Tipo",
    matchesCount: "{{count}} partite",
    none: "Nessuna partita", new: "+ Nuova",
    setGameByGame: "Set {{n}} — game per game",
    confirmDelete: "Eliminare la partita? Azione irreversibile.",
    deleted: "Eliminata",
    singular: "Singolo", duplet: "Doppio", official: "Ufficiale", friendly: "Amichevole",
  },
  stats: {
    perGameSelectionDetails: "{{wins}} riusciti su {{total}} game registrati",
    trendSelectedMatch: "Partita selezionata",
    trendOpenMatch: "Vedi partita",
    tempStepLabel: "Intervallo temperatura (°C)",
    ageStepLabel: "Intervallo età (anni)",
    experienceStepLabel: "Intervallo esperienza (anni)",
    byMyBmiHint: "BMI = peso (kg) / altezza² (m²), usando l'altezza del profilo e il peso registrato per partita.",
    byMyBmiNone: "Nessun dato BMI personale. Inserisci l'altezza nelle impostazioni e il peso per partita.",
    bmiBucketSize: "Intervallo BMI",
    bmiSmallSampleHint: "Tocca una barra per vedere vittorie e partite. Intervalli molto stretti con poche partite non danno indicazioni affidabili.",
    startTimeHalfHourHint: "Per fasce di 30 minuti di inizio (18:30 comprende 18:30–18:59).",
    title: "Stats", subtitle: "Approfondimento sui numeri.",
    none: "Nessuna partita con punteggio.",
    allOpponents: "Tutti gli avversari",
    gamesIServed: "Game al servizio", holdRateOnServe: "Hold rate al mio servizio",
    gamesIReceived: "Game in risposta", opponentHolds: "Hold dell'avversario", breaksIDid: "Break realizzati",
    serviceStats: "Stats servizio", returnStats: "Stats risposta",
    holds: "Hold", breaksAgainst: "Break (contro di me)", holdRate: "Hold rate ({{n}} game)",
    breaksWon: "Break vinti", breakRate: "Break rate ({{n}} game di risposta)",
    smartwatch: "Stats smartwatch", smartwatchHint: "Medie dai tuoi screenshot.",
    avgKcal: "Calorie medie", avgDuration: "Durata media", avgBpm: "BPM medio", maxBpm: "BPM max (medio)",
    perfReport: "Report di rendimento",
    perfHint: "Medie delle valutazioni (1–10).",
    perfNone: "Nessuna valutazione ancora.",
    trendTitle: "Andamento win rate", h2h: "Scontri diretti",
    byCourt: "Win rate per campo", byDay: "Per giorno",
    bySurface: "Per superficie", byTemp: "Per temperatura",
    surfaceNone: "Nessuna superficie registrata.", tempNone: "Nessuna temperatura registrata.",
    perGame: "Successo per game", set: "Set", scope: "Prospettiva",
    scopeAll: "Globale", scopeServing: "Iniziato al servizio", scopeReturning: "Iniziato in risposta",
    metricWin: "Win rate", metricHold: "Hold rate (al servizio)",
    fullTab: "Completo", allSet: "Tutti i set",
    perGameHint: "Tasso di successo per numero di game.",
    firstBreakTitle: "Tasso di vittoria per primo break", firstBreakHint: "Il primo break decide il risultato?",
    fbMe: "Ho brekkato per primo", fbOpp: "Ha brekkato per primo l'avversario", allSurfaces: "Tutte le superfici",
    firstServerTitle: "Tasso di vittoria per primo battitore", firstServerHint: "Chi inizia al servizio influisce sul risultato?",
    fsMatch: "Intera partita", fsMe: "Ho iniziato io al servizio", fsOpp: "Ha iniziato l'avversario",
    returnGames: "Game di risposta", breakRateLabel: "Break rate", gameNumber: "Game",
    hrZonesAvg: "Zone cardiache medie",
    hrZonesAvgHint: "Minuti medi per zona su {{n}} partite con dati orologio.",
    byYear: "Win rate per anno", byMonth: "Win rate per mese",
    byCategoryKind: "Win rate per categoria & tipo",
    byOppAge: "Per età avversario", byOppAgeHint: "Per fascia d'età.", byOppAgeNone: "Età avversario non registrata.",
    byOppExp: "Per esperienza avversario", byOppExpHint: "Anni di tennis.", byOppExpNone: "Esperienza non registrata.",
    byOppLevel: "Percentuale di vittorie per livello avversario", byOppLevelHint: "Livello complessivo dell'avversario (1–10).", byOppLevelNone: "Nessun livello avversario registrato.",
    byOppBmi: "Per BMI avversario", byOppBmiHint: "Indice di Massa Corporea = peso (kg) / altezza² (m²).", byOppBmiNone: "Nessun BMI avversario registrato. Aggiungi altezza e peso per vedere il grafico.",
    showTrend: "Mostra tendenza", hideTrend: "Nascondi tendenza",
    byOppBackhand: "Per rovescio avversario", byOppBackhandNone: "Rovescio non registrato.",
    byBalls: "Per stato palline", byBallsNone: "Stato palline non registrato.",
    ballsNew: "Nuove", ballsUsed: "Usate", ballsUsedN: "Usate ×{{count}}",

    byRainy: "Sotto pioggia", byFloodlights: "Con riflettori",
    byDuration: "Per durata del match", byStartTime: "Per orario di inizio",
    byMyBmi: "Per il mio BMI",
    byOppHandedness: "Per mano dell'avversario", byOppPlaystyle: "Per stile dell'avversario",
    byOppBirthMonth: "Percentuale di vittorie per mese di nascita dell'avversario",
    bySleep: "Per ore di sonno", byTiringDay: "Dopo giornata faticosa",
    byNapped: "Con pisolino", byHeavyMeal: "Dopo pasto pesante",
    byFasted: "A digiuno", byAnxious: "Con ansia",
    byCondition: "Per condizione fisica", byPartner: "Per compagno",
    gameDetail: {
      whenServing: "Quando servivo", whenReturning: "Quando rispondevo",
      held: "Servizio tenuto", broken: "Break subito", opponentHeld: "Servizio avversario tenuto", iBroke: "Ho fatto break",
      deuce: "Parità", pressure: "Pressione",
      serviceCoverage: "Dettaglio registrato per {{detailed}} game al servizio su {{total}}",
      returnCoverage: "Dettaglio registrato per {{detailed}} game in risposta su {{total}}",
      smallSample: "Campione ridotto · n={{count}}",
      noServiceData: "Nessun game al servizio dettagliato", noReturnData: "Nessun game in risposta dettagliato",
      unlock: "Aggiungi i dettagli del game durante la registrazione per vedere questa analisi.",
      serviceTooltip: "{{percentage}}% · {{count}} di {{total}} game al servizio dettagliati",
      returnTooltip: "{{percentage}}% · {{count}} di {{total}} game in risposta dettagliati",
      serviceHeld: { "0": "Servizio tenuto con chi rispondeva a 0", "15": "Servizio tenuto con chi rispondeva a 15", "30": "Servizio tenuto con chi rispondeva a 30", D: "Servizio tenuto dopo la parità", DG: "Servizio tenuto dopo aver affrontato una palla break" },
      serviceBroken: { "0": "Break subito restando a 0", "15": "Break subito restando a 15", "30": "Break subito restando a 30", D: "Break subito dopo la parità", DG: "Break subito dopo aver avuto una palla game" },
      returnHeld: { "0": "Avversario tiene con me a 0", "15": "Avversario tiene con me a 15", "30": "Avversario tiene con me a 30", D: "Avversario tiene dopo la parità", DG: "Avversario tiene dopo una mia palla break" },
      returnBreak: { "0": "Break con avversario a 0", "15": "Break con avversario a 15", "30": "Break con avversario a 30", D: "Break dopo la parità", DG: "Break dopo una palla game dell'avversario" },
    },
  },
  theme: { label: "Tema", court: "Campo di notte", clay: "Terra rossa", daylight: "Luce del giorno", grass: "Erba", hardcourt: "Cemento" },
  insights: {
    pageSubtitle: "Analisi delle tue partite con l'IA.",
    pickOpponent: "Avversario",
    title: "Insights", subtitle: "Pattern dai tuoi dati + coach AI.",
    askAi: "Chiedi all'AI", generating: "Generazione…", aiNarrative: "Narrazione AI",
    notEnough: "Dati insufficienti — continua a registrare.",
    aiError: "Impossibile generare insights.",
  },
  insightsPreview: {
    title: "Cosa scoprirà Tennis Log",
    subtitle: "Registra le tue partite e Tennis Log imparerà gradualmente i pattern dietro i tuoi risultati.",
    learningTitle: "Cosa sta imparando ora Tennis Log",
    learningSubtitle: "Queste aree richiedono un po' più di storico prima di poter dire qualcosa.",
    examplesLabel: "Esempi di ciò che Tennis Log può scoprire",
    badge: "Esempio",
    cta: "Registra la tua prima partita",
    disclaimer: "Sono esempi illustrativi, non conclusioni su di te. Non si basano sui tuoi dati.",
    items: {
      serve: { text: "Rendi meglio nelle partite equilibrate quando la prima di servizio funziona.", unlock: "Registra le valutazioni del servizio in alcune partite per sbloccarlo." },
      opponents: { text: "I tuoi risultati contro avversari più forti stanno migliorando.", unlock: "Registra qualche partita in più con il livello dell'avversario per sbloccarlo." },
      pressure: { text: "I tuoi errori non forzati aumentano nei set ad alta pressione.", unlock: "Registra qualche partita in più per scoprire se la pressione influisce sul tuo rendimento." },
      surface: { text: "Vinci più spesso su una superficie che su un'altra.", unlock: "Registra partite su superfici diverse per sbloccarlo." },
    },
  },
  gaps: {
    title: "Cosa Tennis Log non sa ancora",
    subtitle: "Più complete diventano le tue registrazioni, più intelligente diventa il tuo coach IA.",
    knowledgeTitle: "Conoscenza IA",
    knowledgeHint: "Una stima di quante informazioni utili sono disponibili per un'analisi IA significativa.",
    loggedIn: "Registrato nel {{pct}}% delle tue partite.",
    notYet: "Ancora nessun dato.",
    couldReveal: "Tennis Log potrebbe rivelare:",
    cta: "Inizia a registrarlo",
    doneTitle: "Ottimo!",
    doneBody: "Tennis Log ha già abbastanza dati per insights IA di alta qualità. Continua a registrare partite per aumentare l'affidabilità e scoprire nuovi schemi nel lungo periodo.",
    items: {
      selfRatings: {
        label: "Le tue valutazioni",
        bullets: ["quali colpi decidono davvero le tue partite", "come cambia il tuo livello tra i set", "i tuoi progressi nella stagione"],
      },
      opponentRatings: {
        label: "Valutazioni dell'avversario",
        bullets: ["i punti di forza che contano contro avversari più forti", "le debolezze che emergono solo con pari livello", "analisi personalizzata dello scontro"],
      },
      sleep: {
        label: "Sonno",
        bullets: ["se il sonno influisce sulle vittorie", "la tua resistenza", "il rendimento nel terzo set"],
      },
      nutrition: {
        label: "Alimentazione",
        bullets: ["come i pasti influenzano la prestazione", "se i pasti pesanti riducono la costanza", "come il digiuno cambia la resistenza"],
      },
      weather: {
        label: "Meteo e condizioni",
        bullets: ["come sole, vento o pioggia cambiano il tuo gioco", "il rendimento sotto i riflettori", "il tuo intervallo di temperatura ideale"],
      },
      court: {
        label: "Campo e palline",
        bullets: ["la tua superficie migliore", "come lo stato delle palline influisce sul ritmo", "quali campi si adattano al tuo gioco"],
      },
      emotions: {
        label: "Mente ed energia",
        bullets: ["come la tensione incide sui set combattuti", "l'effetto di una giornata faticosa", "quando la calma ribalta le partite"],
      },
      watch: {
        label: "Smartwatch",
        bullets: ["rilevamento della fatica", "schemi di recupero", "correlazioni tra battito e intensità"],
      },
    },
  },
  composite: {
    title: "Insight compositi",
    subtitle: "Tendenze che emergono solo combinando più segnali delle tue partite.",
    disclaimer: "Gli insight compositi descrivono correlazioni nei tuoi dati, non cause dimostrate. Compaiono solo quando campione e differenza sono sufficienti.",
    showMore: "Mostra altri {{count}}",
    showLess: "Mostra meno",
    direction: {
      positive: "Risultato positivo",
      negative: "Risultato negativo",
      neutral: "Risultato neutro",
    },
    cat: {
      momentum: "Momentum e andamento della partita",
      context: "Rendimento per contesto",
      opponent: "Analisi degli avversari",
      physical: "Condizione fisica",
      development: "Evoluzione",
      matchup: "Analisi dei confronti",
    },
    ev: {
      groups: "Hai vinto {{aWins}} partite su {{aSample}} ({{aRate}}%) {{aLabel}}, rispetto a {{bWins}} su {{bSample}} ({{bRate}}%) {{bLabel}}.",
      single: "Hai vinto {{aWins}} partite su {{aSample}} ({{aRate}}%).",
      ratingTrend: "Autovalutazione media {{recentAvg}} nelle ultime {{recentN}} partite, rispetto a {{prevAvg}} nelle {{prevN}} precedenti.",
    },
    grp: {
      metricAbove: "quando ti sei valutato sopra la tua media in questo aspetto: {{skill}}",
      metricBelow: "quando la tua valutazione è stata pari o inferiore alla media",
      metricAboveSurface: "su {{surface}} quando ti sei valutato sopra la tua media in questo aspetto: {{skill}}",
      metricBelowSurface: "su {{surface}} quando la tua valutazione è stata pari o inferiore alla media",
      lostFirstSet: "dopo aver perso il primo set",
      wonFirstSet: "dopo aver vinto il primo set",
      long: "nelle partite oltre i 90 minuti",
      short: "nelle partite sotto i 90 minuti",
      decider: "nelle partite arrivate al set decisivo",
      overall: "su tutte le partite registrate",
      tiebreak: "nelle partite con tie-break",
      surfaceOn: "su questa superficie: {{surface}}",
      surfaceOff: "sulle altre superfici",
      morning: "nelle partite del mattino",
      afternoon: "nelle partite del pomeriggio e della sera",
      floodlit: "con i riflettori",
      daylight: "alla luce del giorno",
      skillBetter: "quando ti sei valutato più in alto in questo aspetto: {{skill}}",
      skillWorse: "quando l'avversario era valutato più in alto in quell'aspetto",
      goodSleepLong: "nelle partite lunghe dopo 7 ore di sonno o più",
      lowSleepLong: "nelle partite lunghe dopo meno sonno",
      goodSleepDecider: "nelle partite con set decisivo dopo 7 ore di sonno o più",
      lowSleepDecider: "nelle partite con set decisivo dopo meno sonno",
      heavyMeal: "dopo un pasto pesante",
      noHeavyMeal: "senza pasto pesante",
      recentPeriod: "nelle tue ultime {{n}} partite",
      previousPeriod: "nelle {{n}} partite precedenti",
      h2hLostFirst: "contro questo avversario dopo aver perso il primo set",
      h2hOverall: "contro questo avversario in totale",
    },
    msg: {
      mentalPressureStrong: "Nei momenti di pressione decide la testa: {{skill}} — hai vinto {{wins}} di {{sample}} partite così ({{rate}}%) quando ti sei valutato sopra la tua media, contro {{otherWins}} di {{otherSample}} ({{otherRate}}%) quando no.",
      mentalPressureWeak: "Nei momenti di pressione la testa ti costa partite: {{skill}} — hai vinto {{wins}} di {{sample}} ({{rate}}%) quando ti sei valutato sopra la tua media, contro {{otherWins}} di {{otherSample}} ({{otherRate}}%) quando no.",
      serveTightStrong: "Nei set combattuti il servizio fa la differenza: {{skill}} — {{wins}} vinte su {{sample}} ({{rate}}%) quando ti sei valutato sopra la tua media, contro {{otherWins}} su {{otherSample}} ({{otherRate}}%) quando no.",
      serveTightWeak: "I set combattuti mettono in luce un limite al servizio: {{skill}} — {{wins}} vinte su {{sample}} ({{rate}}%) quando ti sei valutato sopra la tua media, contro {{otherWins}} su {{otherSample}} ({{otherRate}}%) quando no.",
      techniqueSurfaceStrong: "Su {{surface}} un aspetto decide il risultato: {{skill}} — {{wins}} vinte su {{sample}} ({{rate}}%) quando ti sei valutato sopra la tua media, contro {{otherWins}} su {{otherSample}} ({{otherRate}}%) quando no.",
      techniqueSurfaceWeak: "Su {{surface}} un aspetto ti frena: {{skill}} — {{wins}} vinte su {{sample}} ({{rate}}%) quando ti sei valutato sopra la tua media, contro {{otherWins}} su {{otherSample}} ({{otherRate}}%) quando no.",
      comebackStrong: "Rimonti bene dopo aver perso il primo set — hai vinto {{wins}} partite su {{sample}} ({{rate}}%).",
      comebackWeak: "Al momento fatichi a rimontare dopo aver perso il primo set — hai vinto solo {{wins}} partite su {{sample}} ({{rate}}%).",
      fadeLong: "Cali nelle partite lunghe — {{wins}} vittorie in {{sample}} partite oltre i 90 minuti ({{rate}}%), rispetto a {{otherWins}} su {{otherSample}} ({{otherRate}}%) in quelle più brevi.",
      thriveLong: "Le partite lunghe ti si addicono — {{wins}} vittorie in {{sample}} partite oltre i 90 minuti ({{rate}}%), rispetto a {{otherWins}} su {{otherSample}} ({{otherRate}}%) in quelle più brevi.",
      deciderStrong: "Nei set decisivi alzi il livello — {{wins}} vittorie su {{sample}} ({{rate}}%), sopra il tuo {{baseline}}% complessivo.",
      deciderWeak: "I set decisivi ti costano partite — {{wins}} vittorie su {{sample}} ({{rate}}%), sotto il tuo {{baseline}}% complessivo.",
      tiebreakStrong: "I tie-break girano a tuo favore — {{wins}} vittorie su {{sample}} partite con tie-break ({{rate}}%), sopra il tuo {{baseline}}% complessivo.",
      tiebreakWeak: "I tie-break ti costano partite — {{wins}} vittorie su {{sample}} partite con tie-break ({{rate}}%), sotto il tuo {{baseline}}% complessivo.",
      surfaceStrong: "Questa superficie ti favorisce: {{surface}} — {{wins}} vittorie in {{sample}} partite ({{rate}}%), rispetto a {{otherWins}} su {{otherSample}} ({{otherRate}}%) altrove.",
      surfaceWeak: "Questa superficie è la più difficile per te: {{surface}} — {{wins}} vittorie in {{sample}} partite ({{rate}}%), rispetto a {{otherWins}} su {{otherSample}} ({{otherRate}}%) altrove.",
      morningBetter: "Al mattino ottieni i risultati migliori — {{wins}} su {{sample}} ({{rate}}%), rispetto a {{otherWins}} su {{otherSample}} ({{otherRate}}%) più tardi.",
      eveningBetter: "Giochi meglio più tardi nella giornata — {{wins}} su {{sample}} ({{rate}}%), rispetto a {{otherWins}} su {{otherSample}} ({{otherRate}}%) al mattino.",
      floodlightsBetter: "Con i riflettori il tuo gioco tiene meglio — {{wins}} su {{sample}} ({{rate}}%), rispetto a {{otherWins}} su {{otherSample}} ({{otherRate}}%) di giorno.",
      floodlightsWorse: "Le partite con i riflettori sono più difficili per te — {{wins}} su {{sample}} ({{rate}}%), rispetto a {{otherWins}} su {{otherSample}} ({{otherRate}}%) di giorno.",
      strongOppSkill: "Contro avversari più forti un aspetto decide la partita: {{skill}} — {{wins}} vittorie su {{sample}} ({{rate}}%) quando eri valutato più in alto.",
      strongOppWeak: "Contro avversari più forti non basta essere valutato più in alto in un aspetto: {{skill}} — {{wins}} vittorie su {{sample}} ({{rate}}%).",
      peerOppSkill: "Contro avversari del tuo livello un aspetto fa la differenza: {{skill}} — {{wins}} vittorie su {{sample}} ({{rate}}%).",
      sleepLongMatches: "Nelle partite lunghe il sonno si vede — {{wins}} vittorie su {{sample}} dopo 7 ore o più ({{rate}}%), rispetto a {{otherWins}} su {{otherSample}} ({{otherRate}}%) con meno.",
      fatigueThirdSet: "Nelle partite che arrivano al set decisivo — {{wins}} vittorie su {{sample}} dopo 7 ore di sonno o più ({{rate}}%), rispetto a {{otherWins}} su {{otherSample}} ({{otherRate}}%) con meno.",
      mealStrongOpp: "Contro avversari più forti il pasto pesante si sente — {{wins}} vittorie su {{sample}} senza pasto pesante ({{rate}}%), rispetto a {{otherWins}} su {{otherSample}} ({{otherRate}}%) con.",
      skillRising: "Un aspetto è in crescita: {{skill}} — circa +{{diff}} punti di valutazione nelle ultime {{sample}} partite.",
      skillFalling: "Un aspetto è in calo: {{skill}} — circa -{{diff}} punti di valutazione nelle ultime {{sample}} partite.",
      formUp: "La tua forma recente è in crescita — {{wins}} vittorie nelle ultime {{sample}} partite ({{rate}}%), rispetto a {{otherWins}} nelle {{otherSample}} precedenti ({{otherRate}}%), contro avversari di livello simile.",
      formDown: "La tua forma recente è calata — {{wins}} vittorie nelle ultime {{sample}} partite ({{rate}}%), rispetto a {{otherWins}} nelle {{otherSample}} precedenti ({{otherRate}}%), contro avversari di livello simile.",
      matchupSkill: "Contro {{opponent}} un aspetto decide i confronti: {{skill}} — {{wins}} vittorie su {{sample}} ({{rate}}%) quando eri valutato più in alto.",
      matchupFirstSet: "Contro {{opponent}} è difficile rimontare un primo set perso — {{wins}} vittorie su {{sample}} ({{rate}}%), rispetto a {{otherWins}} su {{otherSample}} ({{otherRate}}%) in totale.",
      matchupComeback: "Contro {{opponent}} un primo set perso non decide nulla — {{wins}} vittorie su {{sample}} ({{rate}}%), rispetto a {{otherWins}} su {{otherSample}} ({{otherRate}}%) in totale.",
    },
  },
  coach: {
    driverTitle: "Fattore decisivo",
    driverLead: "Un aspetto decide la maggior parte delle tue partite, in entrambe le direzioni: {{topic}}.",
    driverSupport: "Finora: {{goodWins}} vittorie su {{goodSample}} partite ({{goodRate}}%) quando ha funzionato, contro {{badWins}} su {{badSample}} ({{badRate}}%) quando no.",
    title: "Riepilogo del coach IA",
    subtitle: "Le cose più importanti che Tennis Log ha imparato dalle tue partite.",
    notEnough: "Non ci sono ancora abbastanza partite per trarre conclusioni — continua a registrare.",
    strengthTitle: "Punto di forza principale",
    weaknessTitle: "Debolezza principale",
    possibleStrengthTitle: "Possibile punto di forza",
    possibleWeaknessTitle: "Possibile area di miglioramento",
    strengthLead: "I tuoi dati indicano qui il tuo punto di forza principale: {{topic}}.",
    weaknessLead: "I tuoi dati indicano qui la tua debolezza principale: {{topic}}.",
    strengthLeadTentative: "Ci sono primi segnali di un punto di forza qui: {{topic}}, ma il campione è ancora piccolo.",
    weaknessLeadTentative: "Ci sono primi segnali di un'area di miglioramento qui: {{topic}}, ma il campione è ancora piccolo.",
    focusTitle: "Focus per la prossima partita",
    focusOne: "Nella prossima partita concentrati soprattutto qui: {{first}}.",
    focusTwo: "Nella prossima partita concentrati soprattutto qui: {{first}}, mantenendo come arma affidabile: {{second}}.",
    disclaimer: "Sono tendenze che emergono dai tuoi dati, non cause dimostrate.",
    confidence: {
      high: "Affidabilità alta",
      medium: "Affidabilità media",
      low: "Affidabilità bassa",
    },
  },
  watch: {
    uploadScreenshot: "Carica screenshot", uploading: "Caricamento...", aiExtracting: "Estrazione IA...",
    removeImage: "Rimuovi immagine", imageRequired: "Scegli un'immagine (PNG/JPG)",
    uploadFailed: "Caricamento fallito", extractFailed: "Estrazione IA fallita",
    extracted: "Dati estratti dallo screenshot!",
    sourcesHint: "Da Mi Fitness, Garmin, Apple Watch, Zepp ecc. I campi si compilano da soli.",
    multipleHint: "Puoi caricare più di uno screenshot.",
    screenshotAlt: "Screenshot allenamento smartwatch",
    kcal: "Calorie (kcal)", duration: "Durata (min)", avgBpm: "BPM medio", maxBpm: "BPM max",
    hrZones: "Zone cardiache", notes: "Note orologio", notesPlaceholder: "Effetto allenamento, recupero, ecc.",
  },
  surfaces: { hard: "Dura", clay: "Terra rossa", grass: "Erba", carpet: "Moquette" },
  ad: { label: "Pubblicità" },
  footer: {
    rights: "Tutti i diritti riservati.",
    contact: "Contatti", contactTitle: "Contatta Tennis Ledger",
    contactHint: "Inviaci un messaggio.",
    yourEmail: "La tua email", subject: "Oggetto", message: "Messaggio", send: "Apri email",
  },
  install: {
    iosCta: "Installa su iPhone",
    platforms: "Disponibile su Android · Funziona su iPhone",
    iosSheetTitle: "Usa Tennis Log come un'app",
    iosSheetIntro: "Aggiungi Tennis Log alla schermata Home in pochi tocchi, senza App Store.",
    iosSheetStep1: "Apri Tennis Log in Safari",
    iosSheetStep2: "Tocca il pulsante Condividi",
    iosSheetStep3: "Tocca «Aggiungi a Home»",
    iosSheetStep4: "Tocca «Aggiungi»",
    iosReassurance: "Tennis Log comparirà nella schermata Home e si aprirà come un'app.",
    iosNonSafari: "Per installare Tennis Log su iPhone, apri questa pagina in Safari.",
    iosNonSafariHint: "Apri il menu del browser e scegli «Apri in Safari», poi Condividi → Aggiungi a Home.",
    iosNudgeTitle: "Tieni Tennis Log a portata di tocco",
    iosNudgeBody: "Aggiungi Tennis Log alla schermata Home per un'esperienza da app.",
    iosNudgeShowMe: "Mostrami come",
    iosNudgeDismiss: "Non ora",
    cta: "Scarica l'app",
    loading: "L'opzione di installazione si sta caricando, attendi qualche secondo",
    opening: "Apertura della richiesta di installazione…",
    unavailable: "L'opzione di installazione non è disponibile al momento",
    title: "Installa Tennis Log",
    hint: "Aggiungi Tennis Log al tuo dispositivo per aprirlo come una vera app.",
    iosStep1: "Tocca Condividi",
    iosStep2: "Poi seleziona «Aggiungi a Home».",
    iosStep3: "Tocca «Aggiungi» in alto a destra",
    androidStep1: "Tocca il menu del browser ⋮",
    androidStep2: "Scegli «Installa app» o «Aggiungi alla schermata Home».",
    androidStep3: "Conferma l'installazione",
    desktopHint: "Su Chrome o Edge desktop:",
    desktopStep1: "Clicca l'icona di installazione nella barra degli indirizzi",
    desktopStep2: "Oppure apri il menu del browser e scegli «Installa Tennis Log».",
  },

  profileSetup: {
    "title": "Completa il tuo profilo giocatore",
    "subtitle": "Pochi dati rendono statistiche e analisi AI molto più precise.",
    "dob": "Data di nascita",
    "level": "Il tuo livello (1–10)",
    "levelHint": "1 = stai iniziando, 10 = giocatore agonista di alto livello.",
    "unitsMetric": "Metrico",
    "unitsUs": "USA",
    "later": "Più tardi",
    "saved": "Profilo aggiornato",
    "ctaTitle": "Completa il tuo profilo giocatore",
    "ctaBody": "Serve circa un minuto e affina ogni confronto nelle tue statistiche.",
    "ctaAction": "Completa profilo",
    "countryPlaceholder": "Seleziona un paese",
    "countrySearch": "Cerca paese…",
    "countryEmpty": "Nessun paese trovato"
  },
  settings: {
    healthConsent: "Consenso ai dati sanitari",
    healthConsentActive: "Attivo: permetti a Tennis Log di trattare i dati sanitari che aggiungi alle partite.",
    healthConsentInactive: "Non attivo: i dati di smartwatch e frequenza cardiaca non vengono trattati.",
    healthConsentWithdraw: "Revoca il consenso",
    healthConsentWithdrawn: "Consenso revocato e dati sanitari eliminati.",
    healthConsentPartial: "Consenso revocato. Alcuni dati sanitari non sono stati ancora eliminati: riprova a breve.",
    healthConsentError: "Impossibile aggiornare il consenso. Riprova.",
    healthConsentWithdrawHint: "Revocare il consenso eliminerà definitivamente gli screenshot dello smartwatch e i dati sanitari importati (frequenza cardiaca, calorie, ecc.).",
    healthConsentWithdrawTitle: "Revocare il consenso ai dati sanitari?",
    healthConsentWithdrawBody: "Questa azione eliminerà definitivamente gli screenshot dello smartwatch e i dati sanitari importati, inclusi frequenza cardiaca e calorie salvate nelle tue partite. Non può essere annullata.",
    healthConsentWithdrawKeepMatches: "Le schede delle tue partite rimarranno; verranno rimossi solo gli screenshot e i dati sanitari memorizzati.",
    healthConsentWithdrawConfirm: "Revoca il consenso ed elimina i dati sanitari",
    title: "Impostazioni",
    profile: "Profilo",
    displayName: "Nome visualizzato",
    age: "Età",
    country: "Paese",
    gender: "Genere",
    gender_male: "Maschio", gender_female: "Femmina", gender_other: "Altro", gender_prefer_not: "Preferisco non dire",
    level: "Livello tennis",
    level_beginner: "Principiante", level_intermediate: "Intermedio", level_advanced: "Avanzato", level_competitive: "Agonistico",
    profileSaved: "Profilo salvato",
    password: "Password",
    newPassword: "Nuova password",
    changePassword: "Cambia password",
    pwdTooShort: "La password deve avere almeno 6 caratteri",
    pwdChanged: "Password cambiata",
    dataExport: "Esportazione dati",
    dataExportHint: "Scarica tutti i tuoi {{count}} match in CSV.",
    exportCsv: "Esporta in CSV",
    noMatchesExport: "Nessun match da esportare.",
    exported: "{{count}} match esportati",
    units: "Unità di misura",
    unitsHint: "Scegli come vengono mostrati temperature e pesi. I dati sono sempre salvati in °C e kg.",
    unitsMetric: "Metrico (°C, kg)",
    unitsUs: "USA (°F, lb)",
    cookiePrefs: "Preferenze cookie",
    cookiePrefsHint: "Aggiorna quali categorie di cookie consenti.",
    manageCookies: "Gestisci cookie",
    diagnostics: "App e diagnostica",
    diagnosticsHint: "Dettagli tecnici che ci aiutano a riprodurre un problema. Non include nulla di personale.",
    diagnosticsCopy: "Copia diagnostica",
    diagnosticsCopied: "Diagnostica copiata negli appunti",
    diagnosticsCopyFailed: "Copia non riuscita — riprova",
    reportProblem: "Segnala un problema",
    diagnosticsPasted: "Diagnostica copiata — incollala nel tuo messaggio.",
    diagLanguage: "Lingua",
    diagUnits: "Unità",
    diagDisplay: "Modalità di visualizzazione",
    diagDisplayStandalone: "App installata (standalone)",
    diagDisplayBrowser: "Scheda del browser",
    diagBrowser: "Browser",
    diagViewport: "Finestra di visualizzazione",
    diagOrientation: "Orientamento",
    diagHostname: "Nome host",
    dangerZone: "Zona pericolosa",
    deleteAccount: "Elimina account",
    deleteHint: "Elimina definitivamente account e dati. Azione irreversibile.",
    deleteConfirmTitle: "Eliminare l'account?",
    deleteConfirmDesc: "Tutti i match, i dati profilo e l'accesso saranno rimossi definitivamente.",
    deleteForever: "Sì, elimina",
    accountDeleted: "Account eliminato",
    handedness: "Mano", righty: "Destrorso", lefty: "Mancino", heightCm: "Altezza ({{unit}})",
  },
  cookies: {
    title: "La tua privacy",
    intro: "Usiamo i cookie per far funzionare l'app e opzionalmente per misurare l'uso. Scegli cosa consentire.",
    necessary: "Strettamente necessari",
    necessaryDesc: "Richiesti per accesso e funzioni base. Sempre attivi.",
    analytics: "Analitici",
    analyticsDesc: "Statistiche anonime per migliorare l'app.",
    marketing: "Marketing",
    marketingDesc: "Usati dalle reti pubblicitarie per personalizzare.",
    acceptAll: "Accetta tutto",
    rejectAll: "Rifiuta tutto",
    customize: "Personalizza",
    savePrefs: "Salva preferenze",
  },
  invite: {
    title: "Invita un amico",
    subtitle: "Condividi My Tennis Ledger — scansiona il QR o copia il link.",
    copyLink: "Copia link",
    share: "Condividi",
    copied: "Link copiato!",
    shareText: "Traccia la tua storia tennistica con My Tennis Ledger:",
  },
  help: {
    eyebrow: "Centro assistenza",
    title: "Come funziona Tennis Log",
    subtitle: "Un giro rapido di ogni funzionalità, con screenshot e consigli. Clicca una sezione per saltarci.",
    tocTitle: "In questa pagina",
    tocTroubleshooting: "Risoluzione dei problemi",
    tocWhoFor: "A chi è rivolto Tennis Log?",
    tocAbout: "Informazioni su Tennis Log",
    s1Title: "Per iniziare",
    s1Body: "Crea un account con email o Google. Atterrerai sulla Dashboard — vuota per ora. Tocca «+ Nuova partita» per registrarne la prima.",
    s2Title: "La Dashboard",
    s2Body: "Sei riepiloghi in alto: Win rate, Set, Game, Hold rate, Break vinti e Forma attuale. Ognuno riflette il filtro attuale (anno, formato, tipo). Sotto: andamento del win rate e partite recenti.",
    s3Title: "Aggiungere una partita",
    s3Body: "In New Match, inizia registrando avversario, campo e punteggio così il risultato non va perso. Poi usa Score Timeline, Opponent, Context, Performance Review e Smartwatch per aggiungere solo il livello di dettaglio che ricordi davvero. Puoi salvare prima la partita essenziale e tornare più tardi ad arricchire lo stesso record.",
    s4Title: "Elenco partite",
    s4Body: "Cerca per avversario, filtra per formato e tipo, clicca una riga per modificare. Azioni multiple ed export CSV nelle Impostazioni.",
    s5Title: "Stats",
    s5Body: "Analisi approfondita: scontri diretti, per campo, superficie, temperatura, anno/mese, età ed esperienza dell'avversario, stato palle, anche per pioggia o riflettori.",
    s6Title: "Insights IA",
    s6Body: "Clicca «Ask AI» per ottenere un’analisi in stile coach basata sul tuo storico delle partite. L’analisi IA è disponibile dopo aver registrato dati delle partite e, in genere, diventa più informativa man mano che cresce il tuo storico. Quando richiedi gli AI Insights vengono inviati solo dati delle partite consentiti e filtrati per la privacy; gli identificatori personali vengono rimossi o pseudonimizzati in linea con l’Informativa sulla privacy.",
    s7Title: "Import Smartwatch",
    s7Body: "Nella pagina Nuova partita, scorri fino a «Dati smartwatch», carica uno screenshot dell'app dell'orologio e compileremo automaticamente kcal, durata, BPM medi/max e zone FC tramite IA.",
    s8Title: "Esportazione & cancellazione",
    s8Body: "Dalle Impostazioni puoi cambiare password, gestire i cookie, esportare tutto in CSV o eliminare definitivamente il tuo account.",
    ctaTitle: "Pronto a iniziare?",
    ctaDesc: "Veloce e semplice — vedrai le prime stats dopo una partita.",
    ctaBtn: "Crea il tuo account",
    troubleshootingTitle: "Risoluzione dei problemi",
    troubleshootingItems: [
      { q: "Non riesco ad accedere", a: "Assicurati di usare lo stesso provider con cui ti sei registrato (email o Google). Se hai dimenticato la password, usa il link di reset nella schermata di accesso. Ancora bloccato? Usa il link Contatto nel footer con l'email usata." },
      { q: "La mia partita non è stata salvata", a: "Per salvare una partita sono necessari un avversario e un campo. I punteggi e i dettagli aggiuntivi possono essere inseriti progressivamente. Se vedi un messaggio di errore rosso, il modulo indica quale campo manca. Anche i problemi di rete possono bloccare il salvataggio — riprova con una connessione stabile." },
      { q: "Gli AI insights non si generano", a: "Gli AI insights hanno bisogno di almeno alcune partite registrate per trovare pattern. Se hai abbastanza dati ma vedi ancora un errore, il servizio IA potrebbe essere temporaneamente limitato — aspetta un minuto e riprova." },
      { q: "Lo screenshot dello smartwatch non viene analizzato", a: "Il parser funziona meglio con screenshot chiari e ad alto contrasto da Apple Watch, Garmin, Polar o Fitbit. Ritaglia stretto intorno al riepilogo dell'allenamento e assicurati che frequenza cardiaca e durata siano leggibili." },
      { q: "I numeri delle statistiche sembrano sbagliati", a: "La maggior parte delle sorprese nelle stats viene da un ordine di servizio mancante nelle partite game-by-game — senza di esso, l'app non può calcolare hold e break. Modifica la partita e controlla chi ha servito per primo in ogni set." },
    ],
    whoTitle: "A chi è rivolto Tennis Log?",
    whoIntro: "Tennis Log è pensato per ogni giocatore che vuole prendere il proprio tennis un po' più sul serio del semplice ricordare il punteggio mentre torna a casa. Funziona ugualmente bene sia che tu giochi da tre mesi o da tre decenni — la profondità dello strumento cresce con la profondità del tuo log delle partite.",
    whoBeginnersTitle: "Principianti",
    whoBeginnersBody: "Se hai appena iniziato a giocare, la cosa più utile che Tennis Log ti dà è un registro semplice e strutturato delle tue prime partite. Non devi ancora tracciare hold e break. Registra solo avversario, punteggio, superficie e una nota di una riga. Dopo 10-15 partite, avrai una base a cui guardare sei mesi dopo e dire «sono chiaramente migliore ora», con prove invece di sensazioni.",
    whoIntermediateTitle: "Giocatori intermedi",
    whoIntermediateBody: "Per i giocatori di club e di lega, Tennis Log è particolarmente utile. Il tracciamento game-by-game fornisce percentuali reali di hold e break. L’analisi IA è disponibile dopo aver registrato dati delle partite e, in genere, diventa più informativa man mano che cresce il tuo storico. I filtri per superficie e avversario aiutano a esaminare le differenze, mentre un registro strutturato può offrire domande più chiare da portare in allenamento o a una sessione con il coach.",
    whoCompetitiveTitle: "Giocatori agonisti",
    whoCompetitiveBody: "Se gareggi in tornei o in una lega seria, Tennis Log funziona come un database personale di prestazioni. Traccia condizioni, mano dell'avversario, valutazioni di entrambi i lati, dati smartwatch, note mentali — e segmenta le stats per anno, superficie, tipo (amichevole vs ufficiale), partner e altro. Esporta in CSV in qualsiasi momento e porta i dati in una sessione con il coach.",
  },
  landing: {
    heroEyebrow: "Il diario di tennis intelligente",
    heroTitle: "Smetti di indovinare. Inizia a studiare il tuo tennis.",
    heroDesc: "Tennis Log è un diario elegante per amatori e agonisti. Registra ogni partita, consulta statistiche approfondite e lascia che l'IA scopra gli schemi che ti frenano.",
    featuresTitle: "Tutto ciò che ti serve, niente di superfluo",
    f1Title: "Registra ogni partita in pochi secondi",
    f1Desc: "Punteggio per set, avversario, campo, superficie, meteo, persino i tuoi doppi falli — i menu a tendina rendono tutto facile.",
    f2Title: "Statistiche che contano davvero",
    f2Desc: "% vittorie, % servizi mantenuti, % break, set, game, performance per superficie, campo e avversario.",
    f3Title: "Insight con IA",
    f3Desc: "Ricevi un'analisi da coach personale — punti di forza, debolezze e schemi rilevati nel tuo storico.",
    f4Title: "Importazione da smartwatch",
    f4Desc: "Carica uno screenshot da Mi Fitness, Garmin, Apple Watch o Zepp — l'IA compila calorie, BPM e zone FC per te.",
    f5Title: "Tracciamento game per game",
    f5Desc: "Vuoi andare a fondo? Registra le sequenze punto per punto e scopri il tuo tasso di successo per game.",
    f6Title: "7 lingue",
    f6Desc: "EN · EL · ES · FR · DE · IT · JA — il tuo storico tennistico nella tua lingua.",
    previewTitle: "Uno sguardo dentro",
    shotDashLabel: "Dashboard", shotDashTitle: "La tua stagione a colpo d'occhio",
    shotDashDesc: "Sei riepiloghi raccontano la storia: percentuale di vittorie, set, game, percentuale di hold, break vinti e Forma attuale. Ognuno riflette i filtri selezionati.",
    shotAddLabel: "Aggiungi partita", shotAddTitle: "Registra una partita in meno di un minuto",
    shotAddDesc: "Inizia con Fast Track per salvare gli elementi essenziali, poi aggiungi i dettagli che vuoi tramite Score Timeline, Opponent, Context, Performance Review e Smartwatch.",
    shotStatsLabel: "Statistiche", shotStatsTitle: "Approfondimento dei numeri",
    shotStatsDesc: "Singolare vs doppio, amichevole vs ufficiale, % servizi mantenuti, % break, game di risposta — ogni statistica come la vuoi tu.",
    shotTrendLabel: "Trend vittorie", shotTrendTitle: "Vedi evolversi la tua forma",
    shotTrendDesc: "Filtra per singolare, doppio, amichevole o ufficiale — e guarda il tuo % vittorie mobile partita dopo partita.",
    shotPerfLabel: "Performance", shotPerfTitle: "Valuta te stesso e l'avversario",
    shotPerfDesc: "Vota dritto, rovescio, servizio, risposta, volée, smorzata, lob, resistenza, velocità e tattica — per entrambi — e vedili su un grafico radar.",
    shotPerGameLabel: "Successo per game", shotPerGameTitle: "Trova il tuo game debole",
    shotPerGameDesc: "Scopri se cedi nel game 3 o chiudi il game 11 — suddiviso per lato di servizio e set.",
    shotWatchLabel: "Smartwatch", shotWatchTitle: "Battito, calorie, zone — automatico",
    shotWatchDesc: "Carica uno screenshot dell'app del tuo orologio e l'IA compila calorie, durata, BPM medio, BPM massimo e zone FC.",
    howTitle: "Come funziona",
    s1Title: "Aggiungi una partita", s1Desc: "Tocca “+ Nuova partita”, inserisci punteggio, avversario e condizioni. Meno di un minuto.",
    s2Title: "Guarda crescere le tue statistiche", s2Desc: "La dashboard si aggiorna all'istante. Filtra per anno, formato, tipo — come preferisci.",
    s3Title: "Chiedi al coach IA", s3Desc: "Dopo ~10 partite, gli Insight IA individuano schemi: dove cedi, dove brilli.",
    s4Title: "Migliora, partita dopo partita", s4Desc: "Identifica cosa funziona e raddoppia. Esporta in CSV quando vuoi.",
    trust1Title: "Privato e sicuro", trust1Desc: "I tuoi dati sono tuoi. Crittografati, mai venduti.",
    trust2Title: "Fatto per i giocatori", trust2Desc: "Progettato da tennisti, per tennisti.",
    trust3Title: "Tuo, in 7 lingue", trust3Desc: "EN · EL · ES · FR · DE · IT · JA.",
    faqTitle: "Domande frequenti",
    faq1Q: "Quanto costa Tennis Log?", faq1A: "Oggi tutte le funzioni sono disponibili senza costi — sostenute da piccoli annunci. In futuro potremmo introdurre piani a pagamento opzionali per funzioni avanzate.",
    faq2Q: "Devo registrare ogni punto?", faq2A: "Niente affatto. Il log più veloce è solo data + avversario + punteggi dei set. Il tracciamento dettagliato game per game è opzionale.",
    faq3Q: "Come funziona l'importazione da smartwatch?", faq3A: "Fai uno screenshot del riepilogo allenamento in qualsiasi app dell'orologio, caricalo e la nostra IA estrae calorie, durata, BPM medio e massimo e zone FC.",
    faq4Q: "Posso esportare i miei dati?", faq4A: "Sì — esporta tutto in CSV in qualsiasi momento dalle Impostazioni.",
  },
}

data.insightsH = {
  "overall": "Tasso di vittoria complessivo",
  "overallDetail": "{{rate}}% su {{sample}} partite decise.",
  "better": "Più forte nel {{skill}} dell'avversario",
  "betterDetail": "Quando sei più forte nel {{skill}}, vinci il {{rate}}% ({{sample}} partite). Riferimento: {{baseline}}%.",
  "worse": "Più debole nel {{skill}} dell'avversario",
  "worseDetail": "Quando sei più debole nel {{skill}}, vinci il {{rate}}% ({{sample}} partite).",
  "condDetail": "{{rate}}% su {{sample}} partite (rif. {{baseline}}%).",
  "cond": {
    "oneHanded": "Vs rovescio a una mano",
    "twoHanded": "Vs rovescio a due mani",
    "lowSleep": "Poco sonno (<6h)",
    "goodSleep": "Buon sonno (≥7h)",
    "tiring": "Giornata stancante",
    "floodlights": "Sotto i riflettori",
    "rainy": "Tempo piovoso",
    "napped": "Pisolino pomeridiano",
    "heavyMeal": "Pasto pesante",
    "fasted": "A digiuno",
    "anxious": "Ansioso",
    "newBalls": "Palline nuove",
    "official": "Partite ufficiali",
    "friendly": "Partite amichevoli",
    "singles": "Singolo",
    "doubles": "Doppio",
    "surface": "Superficie: {{surface}}"
  },
  "skill": {
    "shot_accuracy": "precisione dei colpi",
    "call_accuracy": "precisione delle chiamate",
    "confrontational_tendency": "calma nei confronti dell'avversario",
    "forehand": "dritto",
    "backhand": "rovescio",
    "service": "servizio",
    "return": "risposta",
    "volley": "volée",
    "drop_shot": "smorzata",
    "lob": "pallonetto",
    "stamina": "resistenza",
    "speed": "velocità",
    "unforced_errors": "controllo degli errori gratuiti",
    "winners": "vincenti",
    "tactics": "tattica",
    "awareness": "lettura del gioco",
    "shot_variety": "varietà di colpi",
    "court_coverage": "copertura del campo",
    "fh_topspin": "topspin di dritto",
    "fh_slice": "slice di dritto",
    "bh_topspin": "topspin di rovescio",
    "bh_slice": "slice di rovescio",
    "first_serve": "prima di servizio",
    "first_serve_pct": "percentuale di prime",
    "first_serve_speed": "velocità della prima",
    "second_serve": "seconda di servizio",
    "second_serve_pct": "percentuale di seconde",
    "second_serve_speed": "velocità della seconda",
    "serve_flat": "servizio piatto",
    "serve_kick": "servizio kick",
    "serve_slice": "servizio slice",
    "smash": "smash",
    "passing_shots": "passanti",
    "composure": "lucidità",
    "concentration": "concentrazione",
    "calmness": "calma",
    "anxiety": "gestione dell'ansia",
    "confidence": "fiducia",
    "fighting_spirit": "grinta",
    "mental_resilience": "resilienza mentale",
    "belief_pre": "fiducia prima del match",
    "belief_in": "fiducia durante il match"
  }
};
data.days = ["Domenica","Lunedì","Martedì","Mercoledì","Giovedì","Venerdì","Sabato"];

data.quicklog = {
  "learnedAccordion": "Guarda cosa ha imparato Tennis Log finora",
  "savedIndicator": "Salvato",
  "fastTrackEyebrow": "Corsia Rapida",
  "fastTrackTagline": "Registra una partita in meno di 30 secondi.",
  "revealMore": "Vuoi risposte più ricche? Scopri di più qui sotto ↓",
  "bonus": "Bonus",
  "continue": "Continua",
  "meterTitle": "Ora, Tennis Log può calcolare:",
  "meterSubtitle": "Queste analisi sono disponibili oggi, in base alle partite che registri.",
  "meterMoreTitle": "Scopri di più per rispondere",
  "meterInfoAria": "Info su queste analisi",
  "editScore": "Modifica punteggio",
  "timelineNoScore": "Nessun punteggio inserito",
  "answers": {
    "winRate": "Percentuale di vittorie totale",
    "history": "Storico partite",
    "gamesPct": "% giochi vinti",
    "setsPct": "% set vinti",
    "monthly": "Percentuale di vittorie per mese",
    "dayOfWeek": "Percentuale di vittorie per giorno della settimana",
    "headToHead": "Confronti diretti con questo avversario"
  },
  "future": {
    "opponent": "Quali profili di avversario si adattano al tuo gioco",
    "timeline": "Come si sviluppano davvero le tue partite",
    "context": "Quali condizioni ti aiutano a giocare al meglio",
    "review": "Quali tue qualità ti fanno vincere le partite",
    "watch": "Cosa dice lo smartwatch sul tuo sforzo"
  },
  "stepTitles": {
    "fastTrack": "Corsia Rapida",
    "opponent": "Avversario",
    "timeline": "Andamento del punteggio",
    "context": "Contesto e condizioni",
    "review": "Valuta la tua prestazione",
    "watch": "Smartwatch"
  },
  "stepIntros": {
    "opponent": "Aggiungi dettagli sull'avversario così Tennis Log costruisce un quadro più ricco di chi affronti. Questo rende possibile un'analisi più approfondita.",
    "timeline": "Registra come si è sviluppato ogni set. Questo rende possibile un'analisi più approfondita dei tuoi schemi di partita.",
    "context": "Cattura le condizioni della partita. Questo rende possibile un'analisi più approfondita del contesto.",
    "review": "Valuta la tua stessa prestazione. Questo rende possibile un'analisi più approfondita delle tue qualità.",
    "watch": "Hai uno smartwatch? Carica uno screenshot e lascia che l'IA compili tutto automaticamente."
  },
  "stepUnlocksLabel": "Inizierai ad alimentare l'analisi di:",
  "unlocks": {
    "opponent": [
      "Risultati contro mancini",
      "Risultati contro giocatori esperti",
      "Risultati per stile di gioco avversario",
      "Risultati contro rovescio a una mano"
    ],
    "timeline": [
      "Come vinci e perdi i tuoi set",
      "Schemi di break e hold",
      "Costanza al servizio tra i set"
    ],
    "context": [
      "Come le condizioni influenzano il tuo gioco",
      "Se sonno o riposo cambiano i risultati",
      "Come il meteo si lega alla tua prestazione"
    ],
    "review": [
      "Quali qualità sono correlate con le tue vittorie",
      "Quali punti deboli ti costano partite",
      "Come evolvono le tue valutazioni nel tempo"
    ],
    "watch": [
      "Calorie e durata",
      "Frequenza cardiaca media e massima",
      "Carico di allenamento e recupero"
    ]
  },
  "successTitle": "Partita salvata.",
  "successBody": "Tennis Log può già rispondere a queste domande sul tuo tennis:",
  "successCtaMatches": "Vedi le mie partite",
  "successCtaContinue": "Aggiungi altri dettagli del match — facoltativo",

  "addMoreDetails": "Aggiungi altri dettagli",
  "finish": "Termina e salva",
  "wantRicher": "Vuoi risposte più ricche?",
  "prev": "Indietro",
  "stepOf": "Passo {{current}} di {{total}}",
  "dontShowRewards": "Non mostrare più",
  "canLabel": "Tennis Log può già identificare:",
  "learnedLabel": {
    "match": "Cosa ha imparato Tennis Log da questa partita:",
    "matches": "Cosa ha imparato Tennis Log dalle tue partite:",
    "tennis": "Cosa sa Tennis Log del tuo tennis:"
  },
  "hintLabel": "Hai un altro minuto?",
  "rewardTitles": {
    "fastTrack": "Partita salvata!",
    "timeline": "Eccellente!",
    "opponent": "Ottimo!",
    "context": "Bel lavoro!",
    "review": "Fantastico!"
  },
  "rewardBodies": {
    "fastTrack": "La tua partita è ora parte del tuo storico tennis.",
    "timeline": "Tennis Log capisce molto meglio come si sviluppano le tue partite.",
    "opponent": "Tennis Log ora conosce molto di più sui giocatori che affronti.",
    "context": "Tennis Log può ora collegare la tua prestazione alle condizioni di gioco.",
    "review": "La tua autovalutazione dà a Tennis Log una ricca fonte di analisi a lungo termine."
  },
  "rewardHints": {
    "fastTrack": "Completa il prossimo passo e Tennis Log inizierà a scoprire:",
    "timeline": "Poi aiuterai Tennis Log a capire i tuoi avversari.",
    "opponent": "Poi registrerai le condizioni della partita.",
    "context": "✨ Hai un altro minuto? Valutiamo ora la prestazione di entrambi i giocatori.",
    "review": "Un ultimo passo opzionale: collega il tuo smartwatch."
  }
};

// --- Progressive logging refinement (conversation-first copy) ---
Object.assign(data.match, {
  "oppGender": "Genere dell'avversario *",
  "genderMale": "Uomo",
  "genderFemale": "Donna",
  "genderOther": "Altro",
  "oppLevel": "Livello complessivo dell'avversario",
  "oppLevel1": "Principiante assoluto",
  "oppLevel5": "Giocatore medio di club",
  "oppLevel10": "Il migliore mai affrontato",
  "oppLevelHint": "7 = forte giocatore di club · 9 = livello torneo",
  "oppBirthYear": "Anno di nascita",
  "oppBirthMonth": "Mese",
  "oppBirthDay": "Giorno",
  "oppTennisSince": "Gioca a tennis dal (anno)",
  "oppTennisSinceCompact": "Gioca dal",
  "oppLegacyValue": "salvato in precedenza",
  "oppBirthInvalid": "Inserisci un anno di nascita completo di 4 cifre (dal 1900).",
  "oppAgePrev": "Età registrata in precedenza",
  "oppExperiencePrev": "Anni di esperienza registrati in precedenza",
  "oppSinceBeforeBirth": "L'anno di inizio del tennis non può precedere l'anno di nascita.",
  "oppSinceFuture": "L'anno di inizio del tennis non può essere nel futuro.",
  "oppSinceRange": "Inserisci un anno completo di 4 cifre (dal 1900).",
  "oppStyleScore": "Difensivo ↔ offensivo",
  "oppStyleLegacy": "Registrato prima come: {{value}}",
  "oppLevelAvg": "Media delle partite precedenti: {{value}} ({{n}})",
  "oppLevelHistory": "Storico del livello",
  "oppAttackTags": "Come mi ha fatto male",
  "oppErrorTags": "Dove sbaglia",
  "oppTagRemembered": "Visto in una partita precedente",
  "attackGroup_serve": "Servizio e primo colpo",
  "attackGroup_shape": "Tipo di colpo",
  "attackGroup_target": "Bersaglio",
  "errorGroup_technical": "Tecnici",
  "errorGroup_situational": "Situazionali",
  "attackTag_big_first_serve": "Prima di servizio pesante",
  "attackTag_aggressive_return": "Risposta aggressiva",
  "attackTag_serve_volley": "Servizio e volée",
  "attackTag_takes_ball_early": "Prende la palla in anticipo",
  "attackTag_heavy_topspin": "Topspin pesante",
  "attackTag_frequent_slice": "Slice frequente",
  "attackTag_drop_shots": "Palle corte",
  "attackTag_short_angles": "Angoli stretti",
  "attackTag_effective_lobs": "Pallonetti efficaci",
  "attackTag_attacks_my_backhand": "Attacca il mio rovescio",
  "attackTag_attacks_my_forehand": "Attacca il mio dritto",
  "attackTag_net_rusher": "Sale a rete",
  "attackTag_open_court": "Apre il campo",
  "attackTag_changes_direction": "Cambia direzione",
  "errorTag_backhand_breaks_down": "Rovescio che cede",
  "errorTag_forehand_breaks_down": "Dritto che cede",
  "errorTag_high_balls": "Fatica sulle palle alte",
  "errorTag_low_balls": "Fatica sulle palle basse",
  "errorTag_vs_heavy_topspin": "Fatica contro il topspin pesante",
  "errorTag_vs_slice": "Fatica contro lo slice",
  "errorTag_vs_drop_shots": "Fatica sulle palle corte",
  "errorTag_volley_errors": "Errori di volée",
  "errorTag_return_errors": "Errori in risposta",
  "errorTag_second_serve_errors": "Seconda di servizio debole",
  "errorTag_errors_when_rushed": "Errori quando è messo sotto pressione",
  "errorTag_errors_on_the_run": "Errori in corsa",
  "errorTag_overhits": "Colpisce troppo forte",
  "errorTag_long_rallies": "Errori negli scambi lunghi",
  "errorTag_under_pressure": "Errori sotto pressione",
  "oppLevelEmpty": "Trascina per valutare il livello complessivo dell'avversario.",
  "oppLevelDesc_10": "Principiante assoluto",
  "oppLevelDesc_15": "Sta iniziando a imparare",
  "oppLevelDesc_20": "Principiante con poca esperienza di partite",
  "oppLevelDesc_25": "Sta sviluppando una continuità di base",
  "oppLevelDesc_30": "Giocatore amatoriale occasionale",
  "oppLevelDesc_35": "Giocatore amatoriale in crescita",
  "oppLevelDesc_40": "Giocatore amatoriale abituale",
  "oppLevelDesc_45": "Giocatore amatoriale solido",
  "oppLevelDesc_50": "Giocatore di club nella media",
  "oppLevelDesc_55": "Giocatore di club competitivo",
  "oppLevelDesc_60": "Giocatore di club forte",
  "oppLevelDesc_65": "Giocatore di club molto forte",
  "oppLevelDesc_70": "Giocatore di club avanzato",
  "oppLevelDesc_75": "Forte giocatore di tornei locali",
  "oppLevelDesc_80": "Giocatore da torneo di alto livello",
  "oppLevelDesc_85": "Giocatore da torneo molto forte",
  "oppLevelDesc_90": "Amatore d'élite / livello regionale",
  "oppLevelDesc_95": "Giocatore eccezionale",
  "oppLevelDesc_100": "Il miglior giocatore che abbia affrontato",
  "oppAttackNotes": "Come attacca questo avversario?",
  "oppAttackNotesPlaceholder": "es. servizio potente, anticipa la palla…",
  "oppErrorNotes": "Come sbaglia questo avversario?",
  "oppErrorNotesPlaceholder": "es. va in difficoltà quando gli pressano il rovescio…"
});
data.quicklog.stepTitles.review = "Valutazione dei giocatori";
Object.assign(data.quicklog.stepIntros, {
  "fastTrack": "Solo l'essenziale — circa 30 secondi.",
  "timeline": "Come si è sviluppata la partita?",
  "opponent": "Raccontaci qualcosa sul tuo avversario.",
  "context": "Sono i dettagli a fare la differenza.",
  "review": "Valuta la prestazione di entrambi i giocatori — col tempo Tennis Log scoprirà cosa ti fa vincere.",
  "watch": "Hai uno smartwatch? Lascia che Tennis Log completi il resto."
});
Object.assign(data.quicklog.rewardTitles, {
  "fastTrack": "Perfetto!",
  "timeline": "Eccellente!",
  "opponent": "Fantastico!",
  "context": "Ottimo!",
  "review": "Ottimo lavoro!",
  "watch": "Tutto pronto!"
});
Object.assign(data.quicklog.rewardBodies, {
  "fastTrack": "La tua partita fa ora parte della tua storia tennistica personale.",
  "timeline": "Tennis Log capisce molto meglio come si sviluppano le tue partite.",
  "opponent": "Tennis Log conosce molto meglio gli avversari che affronti.",
  "context": "Il tuo database personale è diventato più intelligente: Tennis Log collega la tua prestazione alle condizioni di gioco.",
  "review": "Il tuo profilo tennistico è molto più ricco, così come quello del tuo avversario. Tennis Log può iniziare a scoprire quali qualità ti fanno vincere.",
  "watch": "Hai appena creato uno dei record di partita più completi del tuo percorso. Grazie per aiutare Tennis Log a capire il tuo tennis."
});

data.guest = {
  "tryNow": "Provalo ora — senza account",
  "tryNowLine1": "Provalo ora",
  "tryNowLine2": "Senza account",
  "badge": "Sessione ospite",
  "sumScore": "Punteggio",
  "sumType": "Tipo di partita",
  "saveTitle": "La tua prima partita è pronta.",
  "saveSubtitle": "Hai già registrato la tua prima partita. Crea un account gratuito per salvarla in modo permanente e iniziare la tua storia tennistica.",
  "canTitle": "Tennis Log può già calcolare",
  "beginningTitle": "Questo è solo l'inizio.",
  "beginningBody": "Continua e Tennis Log imparerà molto di più da ogni partita che giochi.",
  "google": "Continua con Google",
  "createAccount": "Crea account",
  "haveAccount": "Ho già un account",
  "editAgain": "Modifica questa partita",
  "whyLink": "Perché mi serve un account?",
  "whyBody": "Le tue partite appartengono a te. Un account permette a Tennis Log di:",
  "whyB1": "salvare il tuo storico",
  "whyB2": "sincronizzare tra dispositivi",
  "whyB3": "costruire statistiche a lungo termine",
  "whyB4": "generare insight con l'IA",
  "persisting": "Salvataggio della partita…",
  "successTitle": "Perfetto!",
  "successBody": "La tua prima partita fa ora parte della tua storia tennistica.",
  "successContinue": "Aggiungi altri dettagli del match — facoltativo"
};

data.appWelcome = {
  "heading": "Benvenuto su Tennis Log",
  "subheading": "La tua storia in campo inizia dalla prossima partita.",
  "googleCta": "Continua con Google",
  "googleHelper": "Veloce, sicuro e senza password da ricordare.",
  "guestCta": "Inizia senza account",
  "guestHelper": "Registra subito la tua prima partita. Potrai proteggere i dati con Google più avanti.",
  "haveAccount": "Hai già un account? Accedi",
  "carouselTitle": "Cosa possono rivelare 25 partite?",
  "carouselSubtitle": "Più partite registri, più il tuo gioco diventa chiaro.",
  "carouselTitle2": "Il tuo Tennis Log cresce a ogni partita",
  "carouselSubtitle2": "Scorri per scoprire cosa possono diventare le tue statistiche.",
  "card4": "Ogni sessione, calorie e battito cardiaco",
  "card5": "Le tue partite nel calendario",
  "card1": "La tua stagione a colpo d'occhio",
  "card2": "Guarda come cresce il tuo gioco",
  "card3": "Scopri schemi che da solo non vedi",
  "footer": "Funzioni base gratuite • I tuoi dati restano tuoi • Creato per i giocatori di club",
  "prev": "Precedente",
  "next": "Successivo",
  "mini": {
    "winRate": "Percentuale vittorie",
    "matches": "Partite",
    "sets": "Set vinti",
    "trend": "Andamento vittorie",
    "you": "Tu",
    "opponent": "Avversario",
    "serve": "Servizio",
    "forehand": "Dritto",
    "backhand": "Rovescio",
    "movement": "Movimento",
    "strength": "Punto di forza",
    "strengthBody": "Vinci il 78% delle partite quando ottieni il primo break.",
    "opportunity": "Margine di crescita",
    "opportunityBody": "Il rovescio cala nei terzi set: uno schema di tenuta fisica o concentrazione."
  }
};

data.consent = { health: { title: "Dati sanitari — consenso esplicito", body: "Frequenza cardiaca, zone cardiache, calorie, durata dell’attività e screenshot dello smartwatch sono dati sanitari. Tennis Log li tratta solo con il tuo consenso esplicito, incluso l’invio a un fornitore di IA per generare le tue analisi. È facoltativo e puoi revocarlo in qualsiasi momento nelle Impostazioni, con cancellazione dei dati sanitari già salvati.", checkbox: "Acconsento esplicitamente al trattamento dei miei dati sanitari da parte di Tennis Log come descritto.", enable: "Attiva dati sanitari", optional: "Facoltativo — Tennis Log funziona pienamente anche senza.", granted: "Dati sanitari attivati.", stale: "Il testo del consenso è stato aggiornato. Ricarica la pagina e rileggilo.", error: "Impossibile salvare la scelta. Riprova.", } };

data.share = {
  button: "Condividi risultato",
  dialogTitle: "Condividi risultato",
  dialogSubtitle: "Crea un'immagine di questa partita per i social. Non viene caricato nulla — l'immagine è generata sul tuo dispositivo.",
  showNames: "Mostra i nomi degli altri giocatori",
  showLocation: "Mostra luogo",
  saveImage: "Salva immagine",
  shareImage: "Condividi",
  working: "Creazione…",
  saved: "Immagine salvata.",
  shared: "Condiviso.",
  failed: "Impossibile creare l'immagine. Riprova.",
  shareUnsupported: "Questo dispositivo non può condividere immagini — usa Salva immagine.",
  you: "Tu",
  yourTeam: "La tua squadra",
  opponent: "Avversario",
  opposingTeam: "Squadra avversaria",
  victory: "Vittoria",
  defeat: "Sconfitta",
  draw: "Pareggio",
  retired: "Ritiro",
  incomplete: "Incompleta",
  retiredTag: "RIT.",
};

export default data;
